import { useEffect, useState } from 'react';
import { buildCloudflareUrl } from '../config/cloudflare';
import { getCloudflareAuthHeaders } from '../services/amplifyCompat';

const normalizeMediaUrl = (url) => {
  const normalizedUrl = url.replace(/(https?:\/\/)+/g, 'https://');
  return normalizedUrl.startsWith('/media/')
    ? buildCloudflareUrl(normalizedUrl)
    : normalizedUrl;
};

export const useAuthenticatedMediaUrl = (url) => {
  const [mediaUrl, setMediaUrl] = useState(null);

  useEffect(() => {
    let isCancelled = false;
    let objectUrl = null;
    const normalizedUrl = url ? normalizeMediaUrl(url) : null;

    setMediaUrl(null);

    if (!normalizedUrl) {
      return undefined;
    }

    const loadMedia = async () => {
      try {
        const response = await fetch(normalizedUrl, {
          headers: await getCloudflareAuthHeaders(),
        });

        if (!response.ok) {
          throw new Error(`Unable to load media: ${response.status}`);
        }

        objectUrl = URL.createObjectURL(await response.blob());

        if (isCancelled) {
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setMediaUrl(objectUrl);
      } catch {
        if (!isCancelled) {
          setMediaUrl(normalizedUrl);
        }
      }
    };

    loadMedia();

    return () => {
      isCancelled = true;

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  return mediaUrl;
};
